export default function BookController() {

}